module.exports = __webpack_public_path__ + "static/media/5.52bfa60a.jpg";